import { publish, subscribe, unsubscribe } from "@roc-digital/mxm-base/events";
import { User } from "@roc-digital/mxm-base/dist/data";
import { isInNode } from "@roc-digital/ui-lib";
import React from "react";
import { isMobile as _isMobile } from 'react-device-detect';


declare const googletag: any;
declare const mxmAdState: {
  active: {[key: string]: boolean};
  headerSlot: AdSlot;
};

interface AdSlot {
  getSlotElementId(): string;
  _mxmActive: boolean;
}


export function displayAds() {
  if(isInNode()) {
    return true
  } else {
    return localStorage.getItem('gad') !== '0'
  }
}

if(!isInNode()) {
  subscribe('mxm', 'user-profile', (event) => {
    const user: User = event?.data as any;

    if(!user?.subscribed) {
      localStorage.setItem('gad', Date.now().toString());
    } else {
      localStorage.setItem('gad', '0');
    }

    publish('mxm', 'gad', {});
  })
}

export function useDisplayAds() {
  const [_, inc] = React.useState(0);

  React.useEffect(() => {
    const key = subscribe('mxm', 'gad', (event) => {
      inc(i => i + 1);
    })

    return () => {
      unsubscribe('mxm', 'gad', key)
    }
  }, []);

  return displayAds();
}

export function initAds() {

  if(!window['mxmAdState' as any]) {
    window['mxmAdState' as any] = {active: {}} as any;
  }

  if(!mxmAdState.active) mxmAdState.active = {};

  if(mxmAdState.active['main']) return;
  mxmAdState.active['main'] = true;

  googletag.cmd.push(function() {
    if(isMobile()) {
      mxmAdState.headerSlot = googletag
        .defineSlot('/6177/mxmnews/320x50_1', [320, 50], 'headerSlot')
        .addService(googletag.pubads());
    } else {
      mxmAdState.headerSlot = googletag
        .defineSlot('/6177/mxmnews/728x90_1', [728, 90], 'headerSlot')
        .addService(googletag.pubads());
    }
    
    googletag.pubads().enableSingleRequest();
    googletag.pubads().collapseEmptyDivs();
    googletag.enableServices();
  });
}

/**
 * Displays an ad slot or optionally refreshes it.
 */
export function displayAddSlot(slotKey: keyof typeof mxmAdState, refresh?: boolean) {
  googletag.cmd.push(() => {
    const slot = mxmAdState[slotKey];
    if(!slot) return;
    if(!mxmAdState.active[slotKey]) {
      mxmAdState.active[slotKey] = true;
      googletag.display(slot);
    } else if(refresh) {
      googletag.pubads().refresh([slot]);
    }
  });
}

export function isMobile() {

  if(_isMobile) return true;

  try {
    // return Boolean(navigator.userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i))
    return window.innerWidth < 728 ? true : false
  } catch(err) {
    console.error(err);
  }

  return false;
}